import React from 'react';
import { cx } from './toneStyles';

/**
 * LoadingSpinner — full-page / inline-save spinner (use Skeleton for cards and lists).
 *
 * Props
 *   size   'sm' (20px) | 'md' (32px, default) | 'lg' (48px)
 *   label  accessible name (default 'Loading')
 */
export default function LoadingSpinner({ size = 'md', label = 'Loading', className = '' }) {
  const sizeClasses = {
    sm: 'w-5 h-5 border-2',
    md: 'w-8 h-8 border-4',
    lg: 'w-12 h-12 border-4',
  };

  return (
    <div className={cx('flex items-center justify-center p-4', className)} role="status" aria-label={label}>
      <div
        className={cx(
          sizeClasses[size] || sizeClasses.md,
          'rounded-full animate-spin border-surface-200 border-t-primary-600 dark:border-night-border dark:border-t-primary-400'
        )}
      />
    </div>
  );
}
